<div *ngIf="fromproject" class="row">
    <div class="col">
        <p class="mb-0">{{ 'customercreate.headerline' | trans }}</p>
    </div>
    <div class="col-auto">
        <span (click)="close()" class="material-icons opacity-reverse cursor-pointer f-24">
            arrow_back
            </span>
    </div>
</div>
<div *ngIf="errorMessage!=null" class="alert alert-danger">
    {{ errorMessage | trans }}
</div>
<form #profileForm="ngForm" class="" (ngSubmit)="onRegister()">
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupName">{{ 'customercreate.name' | trans }}</label> 
    <input required id="signupName" type="text" placeholder="{{ 'customercreate.nameplace' | trans }}" maxlength="50" class="form-control" name="title" [(ngModel)]="createCustomer.title" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupDescription">{{ 'customercreate.description' | trans }}</label> 
    <input required id="signupDescription" type="text" placeholder="{{ 'customercreate.descriptionplace' | trans }}" maxlength="50" class="form-control" name="description" [(ngModel)]="createCustomer.description" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupWww">{{ 'customercreate.website' | trans }}</label> 
    <input required id="signupWww" type="url" placeholder="{{ 'customercreate.websiteplace' | trans }}" maxlength="50" class="form-control" name="website" [(ngModel)]="createCustomer.website" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupAddress1">{{ 'customercreate.address' | trans }}</label>
    <input required id="signupAddress1" type="text" placeholder="{{ 'customercreate.addressplace' | trans }}" maxlength="50" class="form-control" name="address1" [(ngModel)]="createCustomer.address1" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupAddress2">{{ 'customercreate.address2' | trans }}</label>
    <input required id="signupAddress2" type="text" placeholder="{{ 'customercreate.address2place' | trans }}" maxlength="50" class="form-control" name="address2" [(ngModel)]="createCustomer.address2" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupCity">{{ 'customercreate.city' | trans }}</label>
    <input required id="signupCity" type="text" placeholder="{{ 'customercreate.cityplace' | trans }}" maxlength="50" class="form-control" name="city" [(ngModel)]="createCustomer.city" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupZip">{{ 'customercreate.zip' | trans }}</label>
    <input required id="signupZip" type="number" placeholder="{{ 'customercreate.zipplace' | trans }}" maxlength="50" class="form-control" name="zip" [(ngModel)]="createCustomer.zip" >
</div>
<div class="form-group mb-2">
    <label class="f-13 font-weight-lighter mb-0" for="signupContact">{{ 'customercreate.contact' | trans }}</label>
    <input required id="signupContact" type="text" placeholder="{{ 'customercreate.contactplace' | trans }}" maxlength="50" class="form-control" name="main_contact" [(ngModel)]="createCustomer.main_contact" >
</div>
<div class="row mb-2 mt-3">
    <div class="col">
        <button id="signupSubmit" type="submit" class="btn-save" >
            <h6 class="btn-save-text">{{ 'customercreate.customercreate' | trans }}</h6>
            </button>
    </div>
</div>
</form>
